import { MediaObjectTypeEnum, MediaObjectUrl } from '@kudos/http-client'
import { Attachment, AttachmentType } from '@shared/hooks/useFileMediaUpload'
import { nth } from 'lodash/fp'

export type AttachmentFieldValue = Attachment & {
  attachmentSrc?: MediaObjectUrl
  fileName?: string
}

const attachmentTypes: Record<MediaObjectTypeEnum, AttachmentType> = {
  [MediaObjectTypeEnum.DOC]: 'document',
  [MediaObjectTypeEnum.FILE]: 'document',
  [MediaObjectTypeEnum.GRAPHIC]: 'document',
  [MediaObjectTypeEnum.GIF]: 'gif',
  [MediaObjectTypeEnum.IMAGE]: 'image',
}

/**
 * A migrated announcement can keep an attachment id after its media record is
 * gone. The form still opens, and that attachment renders as a document so it
 * can be removed.
 */
export const getAttachments = (
  mediaObjectIds: string[] | undefined,
  attachmentUrls: MediaObjectUrl[] | undefined,
): AttachmentFieldValue[] =>
  (mediaObjectIds ?? []).map((mediaObjectId, index) => {
    const attachmentUrl = nth(index, attachmentUrls)

    return {
      mediaObjectId,
      attachmentSrc: attachmentUrl,
      fileName: attachmentUrl?.originalFilename,
      attachmentType: attachmentTypes[attachmentUrl?.type ?? MediaObjectTypeEnum.DOC],
    }
  })
